import classNames from "classnames";

export const CCardTitle = ({ children, uppercase = true }) => {
  return (
    <span
      className={classNames(
        "font-semibold text-base text-[#053C7F]",
        uppercase && "uppercase"
      )}
    >
      {children}
    </span>
  );
};
